(function () {
  var maps = [{ from: 'Head Type', to: 'Screw Head Type' }];
  if (window.MC2_PDP_STEEL === true) maps.push({ from: 'Color', to: 'Finish' });

  function swapLeadingText(el) {
    // Replace only the leading text node so any child (e.g. a swatch-value span) survives.
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue) {
        var t = n.nodeValue.trim();
        for (var m = 0; m < maps.length; m++) {
          if (t === maps[m].from) { n.nodeValue = n.nodeValue.replace(maps[m].from, maps[m].to); return; }
        }
      }
    }
  }

  function relabelLabel(l) {
    var t = l.textContent && l.textContent.trim();
    for (var m = 0; m < maps.length; m++) {
      if (t === maps[m].from) { l.textContent = maps[m].to; return; }
    }
  }

  function relabel(root) {
    // buttons / swatch mode: <fieldset class="variant-option"><legend>Color …</legend>
    root.querySelectorAll('.variant-option legend').forEach(swapLeadingText);
    // single-value: <div class="variant-option" data-testid="variant-option-single">Color<span…></div>
    root.querySelectorAll('.variant-option[data-testid="variant-option-single"]').forEach(swapLeadingText);
    // dropdown mode: <label for="Option-…">Color</label>
    root.querySelectorAll('.variant-option--dropdowns > label').forEach(relabelLabel);
  }

  function bind(vp) {
    if (vp.__mc2Label) return;
    vp.__mc2Label = true;
    var obs = new MutationObserver(function () {
      obs.disconnect();
      relabel(vp);
      obs.observe(vp, { childList: true, subtree: true });
    });
    relabel(vp);
    obs.observe(vp, { childList: true, subtree: true });
  }

  function run() {
    document.querySelectorAll('variant-picker, .variant-picker').forEach(bind);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
